import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

import localForage = require("localforage");

import { SessionStorageService } from "./session-storage.service";
import { config } from "../../../../config/index";

@Injectable()
export class LoggedInResolver implements CanActivate {

    constructor(
        private _router: Router,
        private _sessionStorageService: SessionStorageService) { }
    
    /**
     * function to check if already logged in. If so return to dashboard page.
     * @returns Promise false if already logged In
     */
    async canActivate(): Promise<any> {
        try {
            const isToken = await this._sessionStorageService.readItem(config.storage_key);
            if (isToken) {
                this._router.navigate(['dashboard']);
                return false;
            }
            return true;
        }
        catch (error) {
            this._router.navigate(['logout']);
            return false;
        }
    }
}
